import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { DocumentContentUnavailable } from '../../data/document-content.js';
////////////////////////////////////////////////////////////////////////////////
// getDocument
////////////////////////////////////////////////////////////////////////////////
export const GetDocumentResponse = z.strictObject({
    id: z.string(),
    // `about:blank` when there are no bytes to serve (`contentUnavailable` says why).
    url: z.string().url(),
    mimeType: z.string(),
    // Set when the archive import stored no bytes for this document; the viewer shows the
    // reason instead of loading `url`.
    contentUnavailable: DocumentContentUnavailable.nullable(),
    emailData: z
        .strictObject({
        from: z.string().nullable(),
        to: z.array(z.string()),
        cc: z.array(z.string()),
        subject: z.string().nullable(),
        date: z.string().nullable(),
        body: z.strictObject({
            text: z.string().nullable(),
            html: z.string().nullable(),
        }),
    })
        .nullable(),
    metadata: z
        .record(z.string(), z.union([z.string(), z.strictObject({ latitude: z.number(), longitude: z.number() })]))
        .optional(),
});
////////////////////////////////////////////////////////////////////////////////
// contract
////////////////////////////////////////////////////////////////////////////////
const c = initContract();
export const documentsContract = c.router({
    getDocument: {
        method: 'GET',
        path: '/get-document/:documentId',
        pathParams: z.strictObject({
            documentId: z.string(),
        }),
        responses: {
            200: GetDocumentResponse,
        },
    },
}, { strictStatusCodes: true, pathPrefix: '/documents' });
